import { render, staticRenderFns } from "./HiboQuote.vue?vue&type=template&id=2a376936&"
import script from "./HiboQuote.vue?vue&type=script&lang=ts&"
export * from "./HiboQuote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports